import {fork} from 'redux-saga/effects'
import {loginFlow, logoutFlow, watchRegister} from './auth'
import {watchPresentationRequest, watchNewStationAlarmUpdated, watchNewStationConnectionUpdated} from './presentation'
import {
  watchStationPresentationRequest,
  watchDeviceStatusUpdated,
  watchRecentEvents,
  watchNewEventsUpdated,
  watchDeviceCommand,
  watchReboot,
  watchSyncReq
} from './station'
import {watchHandleMessage, watchSubcribeTopic, watchUnsubcribeTopic} from './mqtt'
import {
  watchFetchCameras,
  watchCreateCameraRequest,
  watchFetchCategories,
  watchUpdateCameraRequest,
  watchDeleteCameraRequest,
  watchFetchCamerasByPermission
} from './camera'
import {watchFetchStations, watchUpdateStationRequest, watchDeleteStationRequest} from './stations'
import {watchFetchGroups, watchCreateGroupRequest, watchUpdateGroupRequest, watchDeleteGroupRequest} from './group'
import {watchFetchAllSystems} from './system'
import {
  watchFetchHubs,
  watchCreateHubRequest,
  watchUpdateHubRequest,
  watchDeleteHubRequest,
  watchUploadHubRequest,
  watchUpgradeHubRequest
} from './hub'
import {watchFetchAccounts, watchUpdateAccountPermissionRequest, watchFetchPermissions, watchDeleteAccountRequest} from './account'
import {watchUpdatePasswordRequest} from './user'
import {watchFetchChartDeviceData, watchFetchTimeLineDeviceData, watchFetchChartPowerMeterDayData, watchFetchChartPowerMeterMonthData, watchExportDeviceData} from './chart'

export default function* root({mqttClient}) {
  yield fork(loginFlow)
  yield fork(logoutFlow)
  yield fork(watchRegister)
  yield fork(watchPresentationRequest)
  yield fork(watchHandleMessage, {mqttClient})
  yield fork(watchSubcribeTopic, {mqttClient})
  yield fork(watchUnsubcribeTopic, {mqttClient})
  yield fork(watchStationPresentationRequest)
  yield fork(watchNewStationAlarmUpdated)
  yield fork(watchNewStationConnectionUpdated)
  yield fork(watchDeviceStatusUpdated)
  yield fork(watchRecentEvents)
  yield fork(watchNewEventsUpdated)
  yield fork(watchDeviceCommand)
  yield fork(watchSyncReq)
  yield fork(watchReboot)
  yield fork(watchFetchCameras)
  yield fork(watchFetchCamerasByPermission)
  yield fork(watchCreateCameraRequest)
  yield fork(watchFetchCategories)
  yield fork(watchUpdateCameraRequest)
  yield fork(watchDeleteCameraRequest)
  yield fork(watchFetchStations)
  yield fork(watchUpdateStationRequest)
  yield fork(watchDeleteStationRequest)
  yield fork(watchFetchGroups)
  yield fork(watchCreateGroupRequest)
  yield fork(watchFetchCategories)
  yield fork(watchUpdateGroupRequest)
  yield fork(watchDeleteGroupRequest)
  yield fork(watchFetchAllSystems)
  yield fork(watchFetchHubs)
  yield fork(watchCreateHubRequest)
  yield fork(watchUpdateHubRequest)
  yield fork(watchDeleteHubRequest)
  yield fork(watchUploadHubRequest)
  yield fork(watchUpgradeHubRequest)
  yield fork(watchFetchAccounts)
  yield fork(watchUpdateAccountPermissionRequest)
  yield fork(watchFetchPermissions)
  yield fork(watchDeleteAccountRequest)
  yield fork(watchUpdatePasswordRequest)
  yield fork(watchFetchChartDeviceData)
  yield fork(watchFetchTimeLineDeviceData)
  yield fork(watchFetchChartPowerMeterDayData)
  yield fork(watchFetchChartPowerMeterMonthData)
  yield fork(watchExportDeviceData)
}



// WEBPACK FOOTER //
// ./src/sagas/index.js